<script setup>
import { computed } from "vue";

const props = defineProps({
  height: { type: String, default: "" },
  width: { type: String, default: "" },
});

const placeholderStyle = computed(() => {
  if (props.height?.match(/[^0-9]/) || props.width?.match(/[^0-9]/)) return {};
  return {
    height: props.height ? `${props.height}px` : undefined,
    width: props.width ? `${props.width}px` : undefined,
  };
});
</script>

<template>
  <div class="placeholder" :style="placeholderStyle" />
</template>

<style lang="scss" scoped>
.placeholder {
  display: inline-block;
  aspect-ratio: 1 / 1;
}
</style>
